import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AddElementComponent } from 'src/app/AppBaseComponents/add-element/add-element.component';
import { ListInterface } from 'src/app/Inteface/list-interface';
import { Literals } from 'src/app/literals';
import { Model } from 'src/app/Models/model';
import { StepModel } from 'src/app/Models/step-model';
import { SuiteModel } from 'src/app/Models/suite-model';
import { CucumberService } from 'src/app/Services/cucumber.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { RestService } from 'src/app/Services/rest.service';
import { SharedService } from 'src/app/Services/shared.service';
import { StepServiceService } from 'src/app/Services/step-service.service';
import { SuiteService } from 'src/app/Services/suite.service';
import { Location } from '@angular/common';

@Component({
  selector: 'ze-runide',
  templateUrl: './runide.component.html',
  styleUrls: ['./runide.component.scss']
})
export class RunideComponent implements OnInit {

  public stepListInterface: ListInterface;
  public suiteListInterface: ListInterface;
  public tabsList: ListInterface[];
  public currentTabType = "";
  private updating: Boolean = false;
  public indexToOpen = 0;
  public isValid: boolean = false;
  public currentIndex: number = 0;
  private cucumberSub: Subscription;
  public hiddenPanel = "";
  public selectedStepId = "";
  mypanel: boolean = false;
  openByFlag: boolean = false;
  showStepView: boolean = false;
  selectedIndex: any;

  constructor(
    public _sharedService: SharedService,
    public cucumberService: CucumberService,
    public suiteService: SuiteService,
    public stepService: StepServiceService,
    private route: ActivatedRoute,
    public restService: RestService,
    private notifys: NotifyService,
    public dialog: MatDialog,
    private location: Location
  ) {
    this.loadView();
  }
  ngOnInit() {
    this.tabsList = new Array<ListInterface>();
    this.loadView();
    this.route.queryParams
        .subscribe(params => {
            if (params.openrecents) {
                this.openByFlag = params.openrecents == 1 ? true : false;
                
                // Priority 1: Try opening by stepId
                if (params.stepId && params.stepId !== 'undefined') {
                    console.log('Opening by Step ID:', params.stepId);
                    this.openSpecificStep(params.stepId);
                } 
                else if (params.suiteId && params.suiteId !== 'undefined') {
                    
                    this.openSpecificSuite(params.suiteId);
                }
                // Fallback: Open first step
                else {
                    console.log('Opening first step (fallback)');
                    this.stepListChange();
                }
            } else {
                this.stepListChange();
            }
        });
}

openSpecificStep(stepId: string) {
    this._sharedService.loaderHide.emit(true);
    this.stepListInterface = new ListInterface();
    this.stepService.getItemsdb2().subscribe(data => {
        // Excludes Web Recorder-tagged steps — those live in its own saved-steps list until promoted.
        this.stepListInterface.models = data['data'].filter((m: any) => !!m && m.source !== 'web_recorder');

        const targetStep = this.stepListInterface.models.find(
            stepModel => stepModel['_id'] === stepId
        );
        
        if (targetStep) {
            console.log('Found and opening step:', targetStep);
            this.onStepSelected(targetStep as StepModel);
        } else {
            console.warn('Step not found by ID, opening first step');
            if (this.stepListInterface.models.length > 0) {
                this.onStepSelected(this.stepListInterface.models[0] as StepModel);
            }
        }
        
        this._sharedService.loaderHide.emit(false);
    });
    
    this.stepListInterface.mainHeadingName = "Step";
    this.stepListInterface.setOnclick(this, "onStepSelected");
    this.stepListInterface.modelService = this.stepService;
}
openSpecificSuite(suiteId: string) {
    this._sharedService.loaderHide.emit(true);
    this.suiteListInterface = new ListInterface();

    this.suiteListInterface.mainHeadingName = "Suites";
    this.suiteListInterface.setOnclick(this, "onSuiteSelected");
    this.suiteListInterface.modelService = this.suiteService;

    this.suiteService.getItemsdb2().subscribe(data => {
        this.suiteListInterface.models = data['data'].filter(Boolean);

        const targetSuite = this.suiteListInterface.models.find(
            suiteModel => suiteModel['_id'] === suiteId
        );

        if (targetSuite) {
            this.onSuiteSelected(targetSuite as SuiteModel);
        } else {
            console.warn('Suite not found by ID, opening first suite');
            if (this.suiteListInterface.models.length > 0) {
                this.onSuiteSelected(this.suiteListInterface.models[0] as SuiteModel);
            }
        }

        this._sharedService.loaderHide.emit(false);
    },
    error => {
        this._sharedService.loaderHide.emit(false);
        throw error;
    });
}

  loadView() {
    this.suiteListChange();
    this.stepListChange();
    this._sharedService.loaderHide.emit(false);
  }

  savedInLib(): void {
    this.loadView();
  }

  resetView() {
    this.loadView();
  }
  modalToList(modal, service) {
    var li = new ListInterface();
    li.models = [];
    li.mainHeadingName = modal.name;
    li._id = modal._id;
    li._type = modal._type;
    li.modelService = service;
    return li;
  }
  addModelToTab(model: Model, service) {
    var flag: Boolean = false;
    for (var i = 0; i < this.tabsList.length; i++) {
      if (
        (this.tabsList[i].mainHeadingName == (model as any).name) &&
        (this.tabsList[i]._type == (model as any)._type)
      ) {
        flag = true;
        this.indexToOpen = i;
        break;
      }
    };
    if (!flag) {
      this.tabsList.push(this.modalToList(model, service))
      this.indexToOpen = this.tabsList.length - 1;
    }    
  }
  spliceTab(event: number) {
    this.tabsList.splice(event, 1);
  }
  resequence(array) {
    let array2 = JSON.parse(JSON.stringify(array))
    for (let index = 0; index < array2.length; index++) {
      array2[index].model['seq_no'] = index;
    }
    return array2
  }
  suiteListChange() {
    this._sharedService.loaderHide.emit(true);
    this.suiteListInterface = new ListInterface();
    this._sharedService.loaderHide.emit(true);
    this.suiteListInterface.mainHeadingName = "Suites";
    this.suiteListInterface.setOnclick(this, "onSuiteSelected");
    this.suiteListInterface.modelService = this.suiteService;
    this.suiteService.getItemsdb2().subscribe(data => {
      this.suiteListInterface.models = data['data'].filter(Boolean);
      this.checkAndRemoveTab();
      this._sharedService.loaderHide.emit(false);
    },
      error => {
        this._sharedService.loaderHide.emit(false);
        throw error;
      });
  }

  checkAndRemoveTab() {
    if(this.tabsList.length > 0 && !this.suiteListInterface.models.some(model => model['_id'] === this.tabsList[this.currentIndex]._id)) {
      this.spliceTab(this.currentIndex);
      if(this.tabsList.length > this.currentIndex + 1) {
        --this.currentIndex;
      }
      this.checkAndRemoveTab();
    }
  }

  onSuiteSelected(model: SuiteModel) {
    // Close any open right-side step view when a left-side suite is opened
    this.showStepView = false;
    this.selectedStepId = "";
    this.currentTabType = Literals.SUITE;
    if (this.tabsList[this.currentIndex] != undefined)
      this.tabsList[this.currentIndex]['models'] = [];
    this.addModelToTab(model, this.suiteService);
    this.getCurrentCucumber();
  }
  stepListChange() {
    this._sharedService.loaderHide.emit(true);
    this.stepListInterface = new ListInterface();
    this.stepService.getItemsdb2().subscribe(data => {
      var datasource = data
      // Excludes Web Recorder-tagged steps — those live in its own saved-steps list until promoted.
      this.stepListInterface.models = data['data'].filter((m: any) => !!m && m.source !== 'web_recorder');
      if(this.selectedStepId !== "" && (this.stepListInterface.models === undefined || (this.stepListInterface.models !== undefined && this.stepListInterface.models.length > 0 && !this.stepListInterface.models.some(stepModel => stepModel['_id'] === this.selectedStepId)))) {
        this.selectedStepId = "";
        this.showStepView = false;
      }
      if (this.openByFlag) {
        //open for first item
        this.onStepSelected(this.stepListInterface.models[0] as StepModel);
        //open for lat item
        // this.onStepSelected(this.stepListInterface.models[this.stepListInterface.models.length - 1] as StepModel)
      }
      this._sharedService.loaderHide.emit(false);
    });
    this.stepListInterface.mainHeadingName = "Step";
    this.stepListInterface.setOnclick(this, "onStepSelected");
    this.stepListInterface.modelService = this.stepService;
  }
  onStepSelected(model: StepModel) {
    this.selectedStepId = model['_id'];
    this.showStepView = true;
  }
  getCurrentCucumber() {
    if (this.currentIndex >= 0)
      switch (this.currentTabType) {
        case Literals.SUITE:
          if (this.cucumberSub)
            this.cucumberSub.unsubscribe();
          if (this.tabsList[this.currentIndex]['model'] == undefined || this.updating) {
            this.updating = false;
            this._sharedService.loaderHide.emit(true);
            this.cucumberSub = this.cucumberService.getSuiteCucumberdb2(this.tabsList[this.currentIndex]._id).subscribe(data => {
              this._sharedService.loaderHide.emit(false);
              if (data.data != undefined) {
                this.tabsList[this.currentIndex]['model'] = data.data;
              }
            });
            this.suiteListChange();
          } break;
        case Literals.STEP:
          break;
      }
  }
  updateCanvas(eve) {
    this._sharedService.loaderHide.emit(true);
    this.updating = true;
    eve = this.resequence(eve.model);
    eve.map((m1) => { m1.seq_no = m1.model.seq_no; m1.model = m1.model._id })
    switch (this.currentTabType) {
      case Literals.SUITE:
        this.cucumberService.addNewInSuitedb2(this.tabsList[this.currentIndex]._id, eve).subscribe(data => {
          this.getCurrentCucumber();
        });
        break;
    }
  }
  deleteCucumberModel(event) {
    for (let i = 0; i < this.tabsList[this.currentIndex]['model'].length; i++) {
      if (this.tabsList[this.currentIndex]['model'][i]._id == event._id) {
        this.tabsList[this.currentIndex]['model'][i].deleted = 1;
      }
    }
  }
  modifyIDE() {
    this.isValid = true;
  }  
  paneltoggle() {
    this.mypanel = !this.mypanel;
    return this.mypanel
  }
  hideStep(event) {
    this.showStepView = !event;
  }
  modifyEventfn(event) {
    this.paneltoggle();
  }
  selectedIndexPage(index: number) {
    this.currentIndex = index;
    if (index >= 0) {
      switch (this.tabsList[index].modelService.constructor.name) {
        case this.suiteService.constructor.name:
          this.currentTabType = Literals.SUITE;
          break;
        case this.stepService.constructor.name:
          this.currentTabType = Literals.STEP;
          break;
        default:
          this.currentTabType = Literals.NONE;
      }
      this.getCurrentCucumber();
    }
    this.checkAndRemoveTab();
  }

  saveAsModel(event:any) {
    try {
      this.updating = true;
      console.log(event);
      let dialogRef = this.dialog.open(AddElementComponent,
        {
          data: {
            event: event,
            title: "Save As",
            name: event.mainHeadingName+" Copy"
          }
        }
      );

      dialogRef.afterClosed().subscribe(result=>{
        if (result) {
          this._sharedService.loaderHide.emit(true);
          let projectIdDb2 = localStorage.getItem("projectIdDb2");
          let existingArtifactId = event._id;
          event = this.resequence(event.model);
          event.map((m1) => { m1.seq_no = m1.model.seq_no; m1.model = m1.model._id })
          if(this.currentTabType==Literals.SUITE){
            var data = this.dataCreatorsuite(projectIdDb2, existingArtifactId, result.name,event);
            return this.restService.put('copysuite',data).subscribe( response => {
              console.log("Response from saveassuite:", response);
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('success', 'Success', "Updated Successfully");
              this.location.go(this.location.path());
              window.location.reload();
            },
            error => {
              console.error("Error in saveassuite:", error);
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('error', 'Error', error);
            }); 
          }
        }
      });
    }catch(e){
  
    }
  }

  dataCreatorsuite(projectId, id, name, datamodel){
    return {
      project: { _id: projectId, dbName: "db2" },
      suite: {_id: id, name: name, type:"suite", dbName: "db2"},
      cucumbers : datamodel
    };
  }

}
